import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';

import AssetContext from './AssetContext';
import PreloadAssetContext from './PreloadAssetContext';
import useActiveChapter from './common/useActiveChapter';
import Effects from './common/Effects';
import RenderCheck from './RenderCheck';
import ErrorBoundary from './ErrorBoundary';
import FovCorrection from './common/FovCorrection';

import Preload, {
  Mount as PreloadMount,
} from './Landscape/Preload';

import Landscape, {
  Mount as LandscapeMount,
  Camera as LandscapeCamera,
  Effects as LandscapeEffects,
} from './Landscape';

import Dyson, {
  Mount as DysonMount,
  Camera as DysonCamera,
  Effects as DysonEffects,
} from './Dyson';

import Obsidian, {
  Mount as ObsidianMount,
  Camera as ObsidianCamera,
  Effects as ObsidianEffects,
} from './Obsidian';

const threeConfig = {
  dpr: [1, 1],
  mode: 'concurrent',
  resize: { scroll: false },
  gl: {
    toneMappingExposure: 0.5,
    precision: 'lowp',
  },
};

export default function Scene({
  StoreContext,
  SignalContext,
  AlchemyContext,
}) {
  const chapter = useActiveChapter();
  const is1 = chapter === 'chapter1';
  const is2 = chapter === 'chapter2';
  const is3 = chapter === 'chapter3';

  return (
    <Canvas { ...threeConfig }>
      <ErrorBoundary>
        <Suspense fallback={ null }>
          <StoreContext>
            <SignalContext>
              <AlchemyContext>
                <PreloadAssetContext>
                  <RenderCheck />
                  <Preload />
                  { is1 && <LandscapeCamera /> }
                  { is1 && <PreloadMount /> }
                </PreloadAssetContext>
                <AssetContext>
                  <RenderCheck />
                    
                  <Landscape />
                  { is1 && <LandscapeMount /> }

                  <Dyson />
                  { is2 && <DysonMount /> }
                  { is2 && <DysonCamera /> }

                  <Obsidian />
                  { is3 && <ObsidianMount /> }
                  { is3 && <ObsidianCamera /> }
                </AssetContext>
                <PreloadAssetContext>
                  <Effects
                    effects={ is1 ? LandscapeEffects : is2 ? DysonEffects : ObsidianEffects }
                  />
                </PreloadAssetContext>
                { is1 && <FovCorrection /> }
              </AlchemyContext>
            </SignalContext>
          </StoreContext>
        </Suspense>
      </ErrorBoundary>
    </Canvas>
  );
};